// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../index';

import { gql } from 'graphql-tag';
export const FilterShapeFragmentDoc = gql`
    fragment filterShape on CatalogueFilterShapeItem {
  __typename
  shape {
    systemCode
    translation(locale: $locale) {
      name
    }
    icon {
      __typename
      id
      url
    }
  }
  totalResults
}
    `;